import React from "react";
import { audio1, audio2, audio3, audio4, audio5 } from "../../../assets/sounds";

const Piano = () => {
  const sounds = [audio1, audio2, audio3, audio4, audio5];

  const playSound = (soundFile) => {
    const audio = new Audio(soundFile);
    audio.play();
  };

  return (
    <div className="piano-container">
      {sounds.map((sound, index) => (
        <span
          key={index}
          onClick={() => playSound(sound)}
          className="piano-key"
        ></span>
      ))}
    </div>
  );
};

export default Piano;
